import PublishStatistics from "../publishStatistics/PublishStatistics";
import Statistics from "../statisticsTable/Statistics";
/**
 * 统计分析
 * */
export  const  statisticalAnalysisRouter =[
    {
        path: '/view/statisticalAnalysis/:configName', //发布统计
        component: PublishStatistics,
    },
    {
        path: '/view/statisticalAnalysis/statistics/:configName', //统计（table)
        component: Statistics,
    },
];